import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'sku.out-of-stock-confirm-modal.title',
    defaultMessage: 'Confirm cancellation',
  },
  body: {
    id: 'sku.out-of-stock-confirm-modal.body',
    defaultMessage:
      "All items in this order are out of stock. We'll notify the customer that you've cancelled the order. You will not receive a payout for the order.",
  },
  removeItemTitle: {
    id: 'sku.out-of-stock-confirm-modal.remove-item-title',
    defaultMessage: 'Remove {itemName} from order',
  },
  removeItemBody: {
    id: 'sku.out-of-stock-confirm-modal.remove-item-body',
    defaultMessage:
      "We'll remove this item from the order and notify the customer. You will not receive a payout for this item.",
  },
  removeOnlyItemBody: {
    id: 'sku.out-of-stock-confirm-modal.remove-only-item-body',
    defaultMessage:
      "This is the only item in this order, so we'll cancel the order and notify the customer. You will not receive a payout for this order.",
  },
  removeItem: {
    id: 'sku.out-of-stock-confirm-modal.remove-item',
    defaultMessage: 'Remove item',
  },
  integrationHint: {
    id: 'sku.out-of-stock-confirm-modal.integration-hint',
    defaultMessage: 'To stop new orders with this item, manage the item in {integrationName}.',
  },
  goBack: {
    id: 'sku.out-of-stock-confirm-modal.go-back',
    defaultMessage: 'Go back',
  },
});
